import { EmptyObject } from 'react-hook-form';
import { useEffectOnce } from 'react-use';

import { UnsignedMedicalInformationAttachmentCountQuery } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { customEventFactory } from '@dreryk/react-common';
import { Badge, BadgePosition, BadgeType } from '@dreryk/react-components';

type UnsignedMedicalInformationAttachmentBadgeProps = {
   readonly patientId: number;
   readonly visible: boolean;
   readonly children: JSX.Element;
};

const [
   dspatchUnsignedMedicalInformationAttachmentCountRefetchEvent,
   registerUnsignedMedicalInformationAttachmentCountRefetchListener,
] = customEventFactory<EmptyObject>('UnsignedMedicalInformationAttachmentCountRefechRefetchEvent');

export const UnsignedMedicalInformationAttachmentBadge = ({
   children,
   visible,
   patientId,
}: UnsignedMedicalInformationAttachmentBadgeProps): JSX.Element => {
   const {
      data: unsignedMedicalInformationAttachmentCount = 0,
      refetch: refetchUnsignedMedicalInformationAttachmentCount,
   } = useCqrsGet<number>(
      () => {
         const query = new UnsignedMedicalInformationAttachmentCountQuery();
         query.patientId = patientId;
         return query;
      },
      {
         enabled: visible,
      }
   );

   useEffectOnce(() =>
      registerUnsignedMedicalInformationAttachmentCountRefetchListener(refetchUnsignedMedicalInformationAttachmentCount)
   );

   return (
      <Badge
         testId={'unsignedMedicalInformationAttachment'}
         type={BadgeType.NEGATIVE}
         count={unsignedMedicalInformationAttachmentCount}
         position={BadgePosition.TOP_RIGHT}
         visible={Boolean(visible && unsignedMedicalInformationAttachmentCount)}
      >
         {children}
      </Badge>
   );
};

export { dspatchUnsignedMedicalInformationAttachmentCountRefetchEvent };
